module.exports = __webpack_public_path__ + "static/media/logo_white.4d789ee6.svg";